import { render } from "./MessageView.vue?vue&type=template&id=8786ff9c&ts=true"
import script from "./MessageView.vue?vue&type=script&lang=ts"
export * from "./MessageView.vue?vue&type=script&lang=ts"

import "./MessageView.vue?vue&type=style&index=0&id=8786ff9c&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.31_vue@3.4.31_typescript@4.1.6__webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__